import React from 'react';
import { StakingProvider } from '../../../contexts/staking/context';
import { featuresScreens } from '../constants';
import FeatureMainLayout from '../partials/FeatureMainLayout';
import AddFundsOptions from './AddFundsOptions';
import CreateStaking from './CreateStaking';
import StakingDetails from './Details';

const StakingFeatures = () => (
  <StakingProvider>
    <FeatureMainLayout>
      <AddFundsOptions keyName={featuresScreens.ADD_FUNDS_OPTIONS} />
      <CreateStaking keyName={featuresScreens.CREATE_STAKING} />
      <StakingDetails keyName={featuresScreens.STAKING_DEAL_DETAILS} />
    </FeatureMainLayout>
  </StakingProvider>
);

export default StakingFeatures;
